import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  withLocale,
  withInplayGames,
  withSports,
  withUser,
  withFeedbackActions,
} from 'core/hocs';
import { isEmptyOrNil, wrapRoute2Locale } from 'core/helpers';
import {
  INPLAY_GAMES_STORE_FIELDS,
  SPORTS_STORE_FIELDS,
  INPLAY_GAMES_TYPES,
  USER_STORE_FIELDS,
  RECOMMENDATIONS_GROUPS,
} from 'core/constants';

import { MediaQuery } from 'components/media-query/media-query';
import { FormattedTag } from 'components/formatted-tag/formatted-tag';
import { prepareSports } from 'helpers/all-inplay';
import { AllInplayMenuMobile } from './all-inplay-menu-mobile/all-inplay-menu-mobile';
import { AllInplayMenuDesktop } from './all-inplay-menu-desktop/all-inplay-menu-desktop';

import './all-inplay-menu.scss';

export class AllInPlayMenuUI extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    liveSportId: PropTypes.number,
    inplayGames: PropTypes.arrayOf(PropTypes.shape()),
    isInplayGamesInProgress: PropTypes.bool.isRequired,
    sports: PropTypes.arrayOf(PropTypes.shape()),
    inplayRecommendations: PropTypes.arrayOf(PropTypes.shape()),
    recommendationsGroup: PropTypes.string.isRequired,
    history: PropTypes.shape().isRequired,
    sendSportClickFeedback: PropTypes.func.isRequired,
  };

  static defaultProps = {
    liveSportId: null,
    inplayGames: null,
    sports: null,
    inplayRecommendations: null,
  };

  componentDidMount() {
    this.checkAndRedirectFromForYou();
  }

  componentDidUpdate() {
    this.checkAndRedirectFromForYou();
  }

  checkAndRedirectFromForYou = () => {
    const {
      liveSportId,
      recommendationsGroup,
      inplayRecommendations,
      locale,
      history,
      sports,
      inplayGames,
    } = this.props;

    if (recommendationsGroup === RECOMMENDATIONS_GROUPS.AI && !liveSportId && !isEmptyOrNil(inplayGames)
    && !isEmptyOrNil(sports) && isEmptyOrNil(inplayRecommendations)) {
      const preparedSports = prepareSports(inplayGames, sports);
      history.push(wrapRoute2Locale(`/live/${preparedSports[0].sportId}`, locale));
    }
  };

  render() {
    const {
      locale,
      liveSportId,
      inplayGames,
      isInplayGamesInProgress,
      sports,
      inplayRecommendations,
      recommendationsGroup,
      sendSportClickFeedback,
    } = this.props;

    return (
      <div className="all-in-play mt-2_5">
        <FormattedTag id="general.all-in-play" tag="div" className="section-title font-weight-bold ml-2 ml-sm-0 mb-1" />
        <MediaQuery down="xs">
          <AllInplayMenuMobile
            locale={locale}
            liveSportId={liveSportId}
            inplayGames={inplayGames}
            isInplayGamesInProgress={isInplayGamesInProgress}
            sports={sports}
            inplayRecommendations={inplayRecommendations}
            recommendationsGroup={recommendationsGroup}
            sendSportClickFeedback={sendSportClickFeedback}
          />
        </MediaQuery>

        <MediaQuery up="sm">
          <AllInplayMenuDesktop
            locale={locale}
            liveSportId={liveSportId}
            inplayGames={inplayGames}
            isInplayGamesInProgress={isInplayGamesInProgress}
            sports={sports}
            inplayRecommendations={inplayRecommendations}
            recommendationsGroup={recommendationsGroup}
            sendSportClickFeedback={sendSportClickFeedback}
          />
        </MediaQuery>
      </div>
    );
  }
}

export const AllInPlayMenu = withRouter(withUser(withLocale(withSports(
  withFeedbackActions(withInplayGames(
    AllInPlayMenuUI,
    INPLAY_GAMES_TYPES.LIVE,
    [
      INPLAY_GAMES_STORE_FIELDS.ITEMS,
      INPLAY_GAMES_STORE_FIELDS.IS_IN_PROGRESS,
      INPLAY_GAMES_STORE_FIELDS.RECOMMENDATIONS,
    ]
  ),
  [SPORTS_STORE_FIELDS.ITEMS])
), [USER_STORE_FIELDS.RECOMMENDATIONS_GROUP])));
